import { StoreConsumptionData } from "../dto/store-consumption.dto";
import { StoreIssuesRequest } from "../dto/store-issues-dto";
import { StoreConsumptionItems } from "../entity/store-consumption-items.entity";
import { StoreConsumption } from "../entity/store-consumption.entity";

export class StoreConsumptionAdapter {

    /**
     * convert data to entity
     * @param storeConsumptionData 
     * @returns entity - StoreConsumption
     */
    public convertDtoToEntity(storeConsumptionData: StoreConsumptionData, code?:string): StoreConsumption {
        const storeConData = new StoreConsumption();
        console.log(storeConsumptionData);
       
        storeConData.indentDate = storeConsumptionData.indentDate;
        storeConData.indentNo = storeConsumptionData.indentNo;
        storeConData.salePerson = storeConsumptionData.salePerson;
        storeConData.consumedDate = storeConsumptionData.consumedDate;
        storeConData.saleOrderId = storeConsumptionData.saleOrderId;
        storeConData.saleOrderItemId = storeConsumptionData.saleOrderItemId;
        storeConData.unitId = storeConsumptionData.unitId;
        storeConData.issuedTo=storeConsumptionData.issuedTo

        if(!storeConsumptionData.storeConsumptionId){
            storeConData.storeConsumptionCode = code;
            storeConData.createdUser = storeConsumptionData.createdUser;
        }else{
            storeConData.updatedUser = storeConsumptionData.updatedUser;
            storeConData.storeConsumptionId = storeConsumptionData.storeConsumptionId;
        }
        
        const conItems: StoreConsumptionItems[]  = []; 
        for (const storeConItems of storeConsumptionData.storeConsumptionItems) {
            const itemsEntity: StoreConsumptionItems = new StoreConsumptionItems();
            if(!storeConItems.storeConsumptionItemsId){
                storeConData.createdUser = storeConsumptionData.createdUser;
            }else{
                itemsEntity.storeConsumptionItemsId = storeConItems.storeConsumptionItemsId;
                storeConData.updatedUser = storeConsumptionData.updatedUser; 
            }
            itemsEntity.itemCategoryId = storeConItems.itemCategoryId;
            itemsEntity.itemId = storeConItems.itemId;
             itemsEntity.availableStock = storeConItems.availableStock;
             itemsEntity.quantity = storeConItems.quantity;
            conItems.push(itemsEntity);
        }
        storeConData.storeConsumptionItems = conItems;
        return storeConData;
    }

    public convertStoreIssuesDtoToEntity(storeConsumptionData: StoreIssuesRequest,code?:string,barcode?:string,productName?:string,departmentId?:number ): StoreConsumption {
        const storeConData = new StoreConsumption();
        console.log(storeConsumptionData);
        console.log('barcode');
        console.log(barcode);
       
        storeConData.indentDate = storeConsumptionData.indentDate;
        storeConData.indentNo = storeConsumptionData.indentNo;
        storeConData.salePerson = storeConsumptionData.salePerson;
        storeConData.consumedDate = storeConsumptionData.consumedDate;
        storeConData.saleOrderId = storeConsumptionData.saleOrderId;
        storeConData.saleOrderItemId = storeConsumptionData.saleOrderItemId;
        storeConData.unitId = storeConsumptionData.unitId;
        storeConData.departmentId = departmentId;
        storeConData.isPreparedMaterial = storeConsumptionData.isPreparedMaterial;
        storeConData.itemId = storeConsumptionData.itemId;
        storeConData.issuedQuantity = storeConsumptionData.issuedQuantity;
        storeConData.issuedTo=storeConsumptionData.issuedTo
        if(storeConsumptionData.barcode != ''){
            storeConData.barcode = storeConsumptionData.barcode;
            storeConData.productName = storeConsumptionData.productName;
        }else{
            storeConData.barcode = barcode;
            storeConData.productName = productName;
        }
        storeConData.stockType = storeConsumptionData.stockType;
        storeConData.transactionType = storeConsumptionData.transactionType;
        storeConData.tracebilityCodeId = storeConsumptionData.tracebilityCodeId;


        if(!storeConsumptionData.storeConsumptionId){
            storeConData.storeConsumptionCode = code;
            storeConData.createdUser = storeConsumptionData.createdUser;
        }else{
            storeConData.updatedUser = storeConsumptionData.updatedUser;
            storeConData.storeConsumptionId = storeConsumptionData.storeConsumptionId;
        }
        
        return storeConData;
    }

    
    
}
